import type { Address } from "../Address.js";
import type { Locale } from "../Locale.js";
import { countryNameMap } from "../names/countryNameMap.js";

export function formatAddress(
	address: Address,
	options: { includeName: boolean; includeCountry: boolean; separator: string; locale: Locale },
): string {
	const lines: string[] = [];
	if (options.includeName) {
		lines.push(`${address.firstName} ${address.lastName}`);
	}
	lines.push(address.street);
	lines.push(`${address.zip} ${address.city}`);
	if (address.state) {
		lines.push(address.state);
	}
	if (options.includeCountry) {
		lines.push(countryNameMap[address.country][options.locale]);
	}
	return lines.join(options.separator);
}
